(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["build-your-box"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initByb(section) {
      if (section.dataset.bybInit === 'true') return;
      section.dataset.bybInit = 'true';

      var boxSize = parseInt(section.dataset.boxSize, 10) || 8;
      var discountCode = section.dataset.discountCode || 'BUILDBOX10';
      var discountPct = parseFloat(section.dataset.discountPct) || 0;
      var currency = section.dataset.currency || 'USD';

      var cards = Array.prototype.slice.call(section.querySelectorAll('[data-card]'));
      var slots = Array.prototype.slice.call(section.querySelectorAll('[data-slot]'));
      var panelCount = section.querySelector('[data-panel-count]');
      var progress = section.querySelector('[data-progress]');
      var statusEl = section.querySelector('[data-status]');
      var subtotalEl = section.querySelector('[data-subtotal]');
      var discountEl = section.querySelector('[data-discount]');
      var discountLine = section.querySelector('[data-discount-line]');
      var totalEl = section.querySelector('[data-total]');
      var cta = section.querySelector('[data-cta]');
      var clearBtn = section.querySelector('[data-clear]');
      var errorEl = section.querySelector('[data-error]');
      var modal = section.querySelector('[data-modal]');
      var modalText = section.querySelector('[data-modal-text]');
      var modalAgain = section.querySelector('[data-modal-again]');
      var panel = section.querySelector('.byb__panel');
      var mbar = section.querySelector('[data-mbar]');
      var mbFill = section.querySelector('[data-mb-fill]');
      var mbStatus = section.querySelector('[data-mb-status]');
      var mbReview = section.querySelector('[data-mb-review]');
      var panelInView = false;

      var ctaLabelFull = cta ? cta.textContent.trim() : 'Add Box to Cart';

      var fmt;
      try {
        var nf = new Intl.NumberFormat(undefined, { style: 'currency', currency: currency });
        fmt = function (cents) { return nf.format(cents / 100); };
      } catch (e) {
        fmt = function (cents) { return '$' + (cents / 100).toFixed(2); };
      }

      var state = {}; // variantId -> qty

      function total() {
        var t = 0;
        cards.forEach(function (c) { t += state[c.dataset.variantId] || 0; });
        return t;
      }

      function contrastColor(hex) {
        var h = (hex || '').replace('#', '').trim();
        if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
        if (h.length < 6) return '#1a1a1a';
        var r = parseInt(h.slice(0, 2), 16);
        var g = parseInt(h.slice(2, 4), 16);
        var b = parseInt(h.slice(4, 6), 16);
        var lum = 0.299 * r + 0.587 * g + 0.114 * b;
        return lum < 145 ? '#f7efe7' : '#1a1a1a';
      }

      function render() {
        var t = total();
        var full = t >= boxSize;

        // Cards
        cards.forEach(function (card) {
          var vid = card.dataset.variantId;
          var qty = state[vid] || 0;
          var add = card.querySelector('[data-add]');
          var stepper = card.querySelector('[data-stepper]');
          var countEl = card.querySelector('[data-count]');
          var incBtn = card.querySelector('[data-inc]');

          card.classList.toggle('is-selected', qty > 0);
          if (qty > 0) {
            add.setAttribute('hidden', '');
            stepper.removeAttribute('hidden');
            countEl.textContent = qty;
          } else {
            add.removeAttribute('hidden');
            stepper.setAttribute('hidden', '');
          }
          if (add) add.disabled = full;
          if (incBtn) incBtn.disabled = full;
        });

        // Tray tokens (flavor order, qty copies each)
        var tokens = [];
        cards.forEach(function (card) {
          var qty = state[card.dataset.variantId] || 0;
          for (var i = 0; i < qty; i++) {
            tokens.push({ accent: card.dataset.accent, image: card.dataset.image, title: card.dataset.title });
          }
        });
        slots.forEach(function (slot, i) {
          var tok = tokens[i];
          var img = slot.querySelector('.byb__slot-img');
          if (tok) {
            slot.classList.add('is-filled');
            slot.style.background = tok.accent || '';
            if (tok.image) {
              if (!img) {
                img = document.createElement('img');
                img.className = 'byb__slot-img';
                img.alt = '';
                img.setAttribute('aria-hidden', 'true');
                slot.appendChild(img);
              }
              if (img.getAttribute('src') !== tok.image) img.setAttribute('src', tok.image);
              img.style.display = '';
            } else if (img) {
              img.style.display = 'none';
            }
          } else {
            slot.classList.remove('is-filled');
            slot.style.background = '';
            if (img) img.remove();
          }
        });

        // Count + progress
        if (panelCount) {
          panelCount.textContent = t + ' / ' + boxSize;
          panelCount.classList.toggle('is-full', full);
        }
        if (progress) progress.style.width = Math.min(t / boxSize * 100, 100) + '%';

        // Status
        if (statusEl) {
          if (t === 0) statusEl.textContent = 'Your box is empty — add ' + boxSize + ' to unlock ' + discountPct + '% off.';
          else if (!full) statusEl.textContent = (boxSize - t) + ' more to fill your box and save ' + discountPct + '%.';
          else statusEl.textContent = 'Box full — ' + discountPct + '% discount applied.';
        }

        // Receipt (cents)
        var subtotal = 0;
        cards.forEach(function (card) {
          var qty = state[card.dataset.variantId] || 0;
          subtotal += qty * (parseInt(card.dataset.priceCents, 10) || 0);
        });
        var discount = full ? Math.round(subtotal * discountPct / 100) : 0;
        var grand = subtotal - discount;
        if (subtotalEl) subtotalEl.textContent = fmt(subtotal);
        if (discountEl) discountEl.textContent = discount > 0 ? '−' + fmt(discount) : fmt(0);
        if (discountLine) discountLine.classList.toggle('is-active', discount > 0);
        if (totalEl) totalEl.textContent = fmt(grand);

        // CTA
        if (cta) {
          cta.classList.toggle('is-full', full);
          cta.disabled = !full;
          cta.textContent = full ? ctaLabelFull : ('Add ' + (boxSize - t) + ' More');
        }

        // Mobile bar content
        if (mbFill) mbFill.style.width = Math.min(t / boxSize * 100, 100) + '%';
        if (mbStatus && statusEl) mbStatus.textContent = statusEl.textContent;
        if (mbReview) mbReview.toggleAttribute('hidden', !full);
        updateMobileBar();
      }

      // Show the fixed mobile bar once items are added and the full
      // Your Box panel is scrolled out of view (CSS gates it to mobile).
      function updateMobileBar() {
        if (!mbar) return;
        var show = total() > 0 && !panelInView;
        mbar.toggleAttribute('hidden', !show);
      }

      if (panel && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          panelInView = entries[0].isIntersecting;
          updateMobileBar();
        }, { threshold: 0.15 });
        io.observe(panel);
      }

      if (mbReview && panel) {
        mbReview.addEventListener('click', function () {
          panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }

      function inc(vid) {
        if (total() >= boxSize) return;
        state[vid] = (state[vid] || 0) + 1;
        render();
      }
      function dec(vid) {
        if (!state[vid]) return;
        state[vid] -= 1;
        if (state[vid] <= 0) delete state[vid];
        render();
      }

      cards.forEach(function (card) {
        var vid = card.dataset.variantId;
        var add = card.querySelector('[data-add]');
        var incBtn = card.querySelector('[data-inc]');
        var decBtn = card.querySelector('[data-dec]');
        if (add) add.addEventListener('click', function () { inc(vid); });
        if (incBtn) incBtn.addEventListener('click', function () { inc(vid); });
        if (decBtn) decBtn.addEventListener('click', function () { dec(vid); });
      });

      if (clearBtn) clearBtn.addEventListener('click', function () { state = {}; render(); });

      function addToCart() {
        if (total() < boxSize) return;
        var lineItems = [];
        cards.forEach(function (card) {
          var qty = state[card.dataset.variantId] || 0;
          if (qty > 0) lineItems.push({ id: parseInt(card.dataset.variantId, 10), quantity: qty });
        });
        if (errorEl) errorEl.setAttribute('hidden', '');
        cta.disabled = true;
        var prevLabel = cta.textContent;
        cta.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: lineItems })
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () {
            // Best-effort cart count refresh for themes listening on these events.
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
            showModal();
            cta.disabled = false;
            cta.textContent = prevLabel;
          })
          .catch(function () {
            if (errorEl) errorEl.removeAttribute('hidden');
            cta.disabled = false;
            cta.textContent = prevLabel;
          });
      }

      function showModal() {
        if (!modal) return;
        var subtotal = 0;
        cards.forEach(function (card) {
          var qty = state[card.dataset.variantId] || 0;
          subtotal += qty * (parseInt(card.dataset.priceCents, 10) || 0);
        });
        var discount = Math.round(subtotal * discountPct / 100);
        var grand = subtotal - discount;
        if (modalText) {
          modalText.innerHTML = 'Your box of ' + boxSize + ' is in the cart with <strong>' + discountPct + '% off</strong> — ' + fmt(grand) + ' total.';
        }
        modal.removeAttribute('hidden');
      }
      function closeModalAndReset() {
        if (modal) modal.setAttribute('hidden', '');
        state = {};
        render();
      }

      if (cta) cta.addEventListener('click', addToCart);
      if (modalAgain) modalAgain.addEventListener('click', closeModalAndReset);
      if (modal) modal.addEventListener('click', function (e) { if (e.target === modal) modal.setAttribute('hidden', ''); });

      render();
    }

    document.querySelectorAll('[data-byb]').forEach(initByb);

    // Re-init for Shopify theme editor section loads.
    document.addEventListener('shopify:section:load', function (e) {
      var sec = e.target.querySelector('[data-byb]');
      if (sec) { sec.dataset.bybInit = ''; initByb(sec); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
